function VIDEO() {
	var cad = '<iframe width="560" height="315" src="https://www.youtube.com/embed/2up2WnhRmoQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
	return cad;
}

export default VIDEO;
